<div
  [id]="messageTypesConfig[type].id"
  [class]="
    messageTypesConfig[type].mainClass +
    ' ' +
    'flex items-center w-full max-w-sm p-4 mb-4 rounded-lg shadow dark:bg-gray-800 fixed top-5 right-5 toast animate__animated animate__faster animate__slideInDown'
  "
  role="alert"
  *ngIf="showToast"
>
  <div
    [class]="
      messageTypesConfig[type].iconClass +
      ' ' +
      'inline-flex items-center justify-center flex-shrink-0 w-8 h-8 rounded-lg'
    "
  >
    <ng-container *ngIf="type === messageTypes.SUCCESS">
      <svg
        class="w-5 h-5"
        aria-hidden="true"
        xmlns="http://www.w3.org/2000/svg"
        fill="currentColor"
        viewBox="0 0 20 20"
      >
        <path
          d="M10 .5a9.5 9.5 0 1 0 9.5 9.5A9.51 9.51 0 0 0 10 .5Zm3.707 8.207-4 4a1 1 0 0 1-1.414 0l-2-2a1 1 0 0 1 1.414-1.414L9 10.586l3.293-3.293a1 1 0 0 1 1.414 1.414Z"
        />
      </svg>
    </ng-container>
    <ng-container *ngIf="type === messageTypes.ERROR">
      <svg
        class="w-5 h-5"
        aria-hidden="true"
        xmlns="http://www.w3.org/2000/svg"
        fill="currentColor"
        viewBox="0 0 20 20"
      >
        <path
          d="M10 .5a9.5 9.5 0 1 0 9.5 9.5A9.51 9.51 0 0 0 10 .5Zm3.707 11.793a1 1 0 1 1-1.414 1.414L10 11.414l-2.293 2.293a1 1 0 0 1-1.414-1.414L8.586 10 6.293 7.707a1 1 0 0 1 1.414-1.414L10 8.586l2.293-2.293a1 1 0 0 1 1.414 1.414L11.414 10l2.293 2.293Z"
        />
      </svg>
    </ng-container>
    <ng-container *ngIf="type === messageTypes.WARNING">
      <svg class="w-5 h-5" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
        <path
          stroke="currentColor"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="2"
          d="M10 11h2v5m-2 0h4m-2.592-8.5h.01M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"
        />
      </svg>
    </ng-container>
    <span class="sr-only">Toast icon</span>
  </div>
  <div class="ms-3 text-sm font-normal">{{ message | translate }}</div>
  <button
    type="button"
    [class]="
      messageTypesConfig[type].buttonClass +
      ' ' +
      'ms-auto -mx-1.5 -my-1.5 rounded-lg focus:ring-2 p-1.5 inline-flex items-center justify-center h-8 w-8 dark:bg-gray-800 dark:hover:bg-gray-700'
    "
    aria-label="Close"
    (click)="closeToast()"
  >
    <span class="sr-only">Close</span>
    <svg class="w-3 h-3" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 14 14">
      <path
        stroke="currentColor"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="2"
        d="m1 1 6 6m0 0 6 6M7 7l6-6M7 7l-6 6"
      />
    </svg>
  </button>
</div>
